import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'updateCustomerRefCTAButton': {
    id: 'license.controlPanel.update.customerReference.button.cta.label',
    description: 'Label for update reference number CTA button.',
    defaultMessage: 'Update reference number',
  },
  'updateCustomerRefDialogTitle': {
    id: 'license.controlPanel.update.customerReference.dialog.title',
    description: 'Title for update reference number dialog.',
    defaultMessage: 'New customer reference',
  },
  'updateCustomerRefConfirmTitle': {
    id: 'license.controlPanel.update.customerReference.confirm.title',
    description: 'Title for update reference number confirm dialog.',
    defaultMessage: 'Update reference number?',
  },
  'updateCustomerRefConfYesButton': {
    id: 'license.controlPanel.update.customerReference.confirm.button.yes',
    description: 'Label for update reference number confirm yes button.',
    defaultMessage: 'Yes',
  },
  'updateCustomerRefConfNoButton': {
    id: 'license.controlPanel.update.customerReference.confirm.button.no',
    description: 'Label for update reference number confirm no button.',
    defaultMessage: 'No',
  },
  'updateCustomerRefDialYesButton': {
    id: 'license.controlPanel.update.customerReference.dialog.button.do',
    description: 'Label for update reference number dialog do button.',
    defaultMessage: 'Update',
  },
  'updateCustomerRefDialNoButton': {
    id: 'license.controlPanel.update.customerReference.dialog.button.cancel',
    description: 'Label for update reference number dialog cancel button.',
    defaultMessage: 'Cancel',
  },
  'toggleLicenseContinuousOffCTAButton': {
    id: 'license.controlPanel.update.licenseContinous.button.ctaToOff.label',
    description: 'Label for toggling license to non-continous CTA button.',
    defaultMessage: 'Change to non-continous',
  },
  'toggleLicenseContinuousOnCTAButton': {
    id: 'license.controlPanel.update.licenseContinous.button.ctaToOn.label',
    description: 'Label for toggling license to continous CTA button.',
    defaultMessage: 'Change to continous',
  },
  'toggleLicenseContinuousConfirmTitle': {
    id: 'license.controlPanel.update.licenseContinous.confirm.title',
    description: 'Title for update reference number confirm dialog.',
    defaultMessage: 'Change automatic renewal',
  },
  'toggleLicenseContinuousConfYesButton': {
    id: 'license.controlPanel.update.licenseContinous.confirm.button.yes',
    description: 'Label for toggling license continuous state yes-button.',
    defaultMessage: 'Yes',
  },
  'toggleLicenseContinuousConfNoButton': {
    id: 'license.controlPanel.update.licenseContinous.confirm.button.no',
    description: 'Label for update reference number confirm no button.',
    defaultMessage: 'Cancel',
  },
  'toggleLicenseContinuousOffDisc': {
    id: 'license.controlPanel.update.licenseContinous.disc.off',
    description: 'Disclaimer for turning automatic renewal off for a license.',
    defaultMessage: 'Do you want to turn off automatic renewal for the license? This means, that the license won\'t be continued when the current billing period ends.',
  },
  'toggleLicenseContinuousOnDisc': {
    id: 'license.controlPanel.update.licenseContinous.disc.on',
    description: 'Disclaimer for turning automatic renewal on for a license.',
    defaultMessage: 'Do you want to turn on automatic renewal for the license? This may or may not mean, that the license will be automatically billed when the new billing period starts.',
  },
  'changeContactPersonCTAButton': {
    id: 'license.controlPanel.update.contactPerson.button.cta.label',
    description: 'Label for changing license contact person CTA button.',
    defaultMessage: 'Change contact person',
  },
  'confirmChangeContactPersonButton': {
    id: 'license.controlPanel.update.contactPerson.button.confirm.label',
    description: 'Label for change contact person confirm button.',
    defaultMessage: 'Change',
  },
  'cancelChangeContactPersonButton': {
    id: 'license.controlPanel.update.contactPerson.button.cancel.label',
    description: 'Label for change contact person cancel button.',
    defaultMessage: 'Cancel',
  },
});
